module.exports = __webpack_public_path__ + "img/forward.59b92e82.svg";